var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":_vm.id}}),_c('div',{staticClass:"d-none",attrs:{"id":_vm.id+'iv'}}),(_vm.description)?_c('p',{staticClass:"mt-2"},[_vm._v(_vm._s(_vm.description))]):_vm._e(),_c('b-button',{staticClass:"btn btn-orange-border mt-2",on:{"click":_vm.downloadQr}},[_vm._v(_vm._s(_vm.$t('download')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }